<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-11 15:42:24
 * @LastEditors: yd
 * @LastEditTime: 2020-07-11 16:01:55
--> 
<template>
  <div class="bigbox">
    <v-text-field :label="label"
                  :rules="rules"
                  v-model="inputName"
                  :disabled='disabled'
                  :prepend-icon='prependicon'
                  hide-details="auto"
                  @click="popup"></v-text-field>
    <v-dialog v-model="dialog"
              width="500">
      <v-card>
        <v-card-text class="dialog">
          <v-row>
            <v-col cols="12">
              <v-text-field label="label"
                            :rules="dialogrules"
                            hide-details="auto"
                            @click="popup"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field label="label"
                            :rules="dialogrules"
                            hide-details="auto"
                            @click="popup"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field label="label"
                            :rules="dialogrules"
                            hide-details="auto"
                            @click="popup"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    rules: {
      type: String,
      defauit: '必填'
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    prependicon: {
      type: String
    },
    inputName: {
      type: [String, Array]
    }
  },
  mode: {
    prop: 'inputName',
    event: 'change'
  },
  data () {
    return {
      dialog: false,
      dialogrules: [
        value => !!value || '不能为空'
      ]
    };
  },
  created () { },
  mounted () { },
  methods: {
    popup () {
      this.dialog = true
    }
  },
  computed: {},
  watch: {},
};
</script>

<style scoped>
.bigbox {
  position: relative;
}
.dialog {
  /* position: absolute;
  top: 0; */
}
</style>
